/* Built In Imports */
/* External Imports */
import mixpanel from 'mixpanel-browser';

/* Components */
import config from '@config';

/**
 *
 * @param {String} path
 * @returns
 */
export const mixPanel = path => {
  // console.log('mixPanel is', path, buildType);
  // Initialize Mixpanel with your project key

  let MIXPANEL_TOKEN = config.MIXPANEL_TOKEN;
  if(path?.indexOf('linga-bhairavi/us/') > -1){
    MIXPANEL_TOKEN = config.MIXPANEL_TOKEN_US;
  }
  
  let mixPanelEnable = true;

  if (!MIXPANEL_TOKEN) {
    mixPanelEnable = false;
  }
  if (
    !MIXPANEL_TOKEN ||
    (path?.indexOf('inner-engineering') > -1 &&
      config.ENV_NAME !== 'production')
  ) {
    mixPanelEnable = true;
  }

  // || path?.indexOf('/wisdom') > -1 ||
  // path?.indexOf('/sadhguru-exclusive') > -1 ||
  // path?.indexOf('/sadhguru') > -1 ||
  // path?.indexOf('/yoga-meditation') > -1 ||
  // path?.indexOf('/events') > -1 ||
  // path?.indexOf('/center') > -1 ||
  // path?.indexOf('/health') > -1 ||
  // path?.startsWith('/project-samskriti') ||
  // path?.startsWith('/sadhguru-academy') ||
  // path?.startsWith('/isha-home-school') ||
  // path?.startsWith('/linga-bhairavi') ||
  // path?.startsWith('/shivanga') ||
  // path?.startsWith('/mahashivratri')

  // console.log(
  //   'isIeoPage is',
  //   mixPanelEnable,
  //   config.ENV_NAME,
  //   path,
  //   MIXPANEL_TOKEN
  // );

  if (mixPanelEnable && MIXPANEL_TOKEN) {
    // console.log('mixpanel init starts', MIXPANEL_TOKEN, isIeoPage);

    mixpanel.init(MIXPANEL_TOKEN || '', {
      debug: config.MIXPANEL_DEBUG,
      track_pageview: false,
      ignore_dnt: true,
      //persistence: 'localStorage',
    });
  }

  if (mixPanelEnable && mixpanel && MIXPANEL_TOKEN) {
    const action = {
      identify: id => {
        mixpanel.identify(id);
      },
      alias: id => {
        mixpanel.alias(id);
      },
      track: (name, props) => {
        mixpanel?.track(name, props);
      },
      // people: () => {
      //   set: props => {
      //     mixpanel.people.set(props);
      //   };
      // },
      people: {
        set: props => mixpanel.people.set(props),
      },
  
    };

    return action;
  }
  return {};
};
